import styled from 'styled-components';

export const SelectContextItemContainer = styled.div`
  overflow: hidden;
`;

export const SelectContextItemContent = styled.div`
  margin-top: -8px;
  margin-bottom: -2px;

  span {
    font-size: ${({ theme }) => theme.fontSizes.verySmall};
    margin: 0;
    color: ${({ theme }) => theme.colors.text2};

    svg {
      padding-top: 4px;
      margin: 0 2px;
    }
  }
`;

export const SelectContextItemTitle = styled.p`
  margin: 0;
  margin-top: 2px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text1};
  font-size: ${({ theme }) => theme.fontSizes.small};
`;
